import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { GridModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PHBHPGridComponent } from './ph-bhp-grid/ph-bhp-grid.component';
import { PopupAnchorDirective } from './ph-bhp-grid/popup.anchor-target.directive'
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { SearchPipe } from './search.pipe';
import { SanitizerUrl } from './sanitizerUrl.pipe';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { PHBHPSidepanelComponent } from './ph-bhp-sidepanel/ph-bhp-sidepanel.component';
import { PhLoaderComponent } from './ph-loader/ph-loader.component';
import { ChartsModule } from '@progress/kendo-angular-charts';
// import { AngularFireMessaging } from '@angular/fire/messaging';
// import { AngularFireModule } from 'angularfire2';
import { PhBhpNotificationService } from './ph-bhp-notification/ph-bhp-notification.service';
import { environment } from './ph-bhp-notification/environment';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TooltipModule as BsTooltipModule } from 'ngx-bootstrap/tooltip';
import { RequestInterceptorService } from './token-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PHBHPLayoutPackageComponent } from './ph-bhp-layout-package.component';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
import { ToastComponent } from 'src/app/layout/toast/toast.component';
import { LightTableComponent } from './bd-light-table/light-table.component';
import { MatTableModule } from '@angular/material/table';
import { BdSearchComponent } from './bd-search/bd-search.component';
import { MatIconModule } from '@angular/material/icon';

// common libraries
@NgModule({
  declarations: [
    PHBHPGridComponent,
    SearchPipe,
    PopupAnchorDirective,
    PHBHPSidepanelComponent,
    PhLoaderComponent,
    SanitizerUrl,
    PHBHPLayoutPackageComponent,
    ToastComponent,
    LightTableComponent,
    BdSearchComponent
  ],
  imports: [

    FormsModule,
    BrowserModule,
    GridModule,
    ButtonsModule,
    DropDownListModule,
    BrowserAnimationsModule,
    PHBHPLocalizePackageModule,
    RouterModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    ReactiveFormsModule,
    ChartsModule,
    NotificationModule,
    //AngularFireModule.initializeApp(environment.firebase),
    TooltipModule,
    BsTooltipModule.forRoot(),
    PhBhpUiModule,
    MatTableModule,
    MatIconModule
  ],
  exports: [
    FormsModule,
    BrowserModule,
    GridModule,
    BrowserAnimationsModule,
    ModalModule,
    BsDropdownModule,
    RouterModule,
    PHBHPGridComponent,
    NotificationModule,
    SearchPipe,
    SanitizerUrl,
    ReactiveFormsModule,
    PHBHPSidepanelComponent,
    PhLoaderComponent,
    ChartsModule,
    ToastComponent,
    LightTableComponent,
    BdSearchComponent
  ],
  providers: [PhBhpNotificationService, /*AngularFireMessaging, */
    {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestInterceptorService,
    multi: true
  }
]
})
export class PHBHPLayoutPackageModule { }
